import { render, staticRenderFns } from "./FamilyShowcase.vue?vue&type=template&id=045282da&"
import script from "./FamilyShowcase.vue?vue&type=script&lang=js&"
export * from "./FamilyShowcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports